import { Logger } from './useLoggerCore'

export class ConsoleLogger extends Logger {
  log(component: string, event: string, data?: any) {
    super.log(component, event, data)
    // Console output for development
    console.log(`[${component}] ${event}`, data ? data : '')
  }

  warn(component: string, event: string, data?: any) {
    super.warn(component, event, data)
    console.warn(`[${component}] ${event}`, data ? data : '')
  }

  error(component: string, event: string, data?: any) {
    super.error(component, event, data)
    console.error(`[${component}] ${event}`, data ? data : '')
  }

  debug(component: string, event: string, data?: any) {
    super.debug(component, event, data)
    console.debug(`[${component}] ${event}`, data ? data : '')
  }
}

export function useLoggerConsole() {
  const logger = new ConsoleLogger()

  return {
    log: (component: string, event: string, data?: any) => logger.log(component, event, data),
    warn: (component: string, event: string, data?: any) => logger.warn(component, event, data),
    error: (component: string, event: string, data?: any) => logger.error(component, event, data),
    debug: (component: string, event: string, data?: any) => logger.debug(component, event, data),
    getLogs: () => logger.getLogs(),
    clearLogs: () => logger.clearLogs(),
    getLogsByComponent: (component: string) => logger.getLogsByComponent(component),
    getLogsByLevel: (level: 'info' | 'warn' | 'error' | 'debug') => logger.getLogsByLevel(level)
  }
}
